module.exports = __webpack_public_path__ + "static/media/BE.d8bddc15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BE.svg
// module id = 2109
// module chunks = 7